(function() {
  const customDiscountedPrice = window.themeSettings?.productDiscountedPrice;
  
  if (!customDiscountedPrice || customDiscountedPrice.trim() === '') {
    return;
  }

  let widgetObserver = null;
  let priceObserver = null;

  function updateRechargePrice() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return false;

    const targetRoot = widget.shadowRoot || widget;
    const priceElements = targetRoot.querySelectorAll('[part="rc-purchase-option__discounted-price"]');
    
    if (priceElements.length === 0) return false;

    let updated = false;
    priceElements.forEach(function(priceElement) {
      for (let i = priceElement.childNodes.length - 1; i >= 0; i--) {
        const node = priceElement.childNodes[i];
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text && text.includes('$') && text !== customDiscountedPrice) {
            node.textContent = customDiscountedPrice;
            updated = true;
            break;
          }
        }
      }
    });
    
    return updated;
  }

  function attachPriceObserver() {
    if (priceObserver) return;

    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return;

    const targetRoot = widget.shadowRoot || widget;
    
    priceObserver = new MutationObserver(function() {
      updateRechargePrice();
    });

    priceObserver.observe(targetRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });

    updateRechargePrice();
  }

  function init() {
    if (document.querySelector('recharge-subscription-widget')) {
      attachPriceObserver();
      return;
    }

    widgetObserver = new MutationObserver(function(mutations) {
      if (document.querySelector('recharge-subscription-widget')) {
        attachPriceObserver();
        if (widgetObserver) {
          widgetObserver.disconnect();
          widgetObserver = null;
        }
      }
    });

    widgetObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

